import { render, staticRenderFns } from "./IntegrationCard.vue?vue&type=template&id=2ae19854&scoped=true&"
import script from "./IntegrationCard.vue?vue&type=script&lang=js&"
export * from "./IntegrationCard.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationCard.vue?vue&type=style&index=0&id=2ae19854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae19854",
  null
  
)

export default component.exports